import { FunctionComponent } from "react";

import { MessageBar, MessageBarType } from "@bps/fluent-ui";
import { routes } from "@libs/routing/routes.ts";
import { Navigate } from "@ui-components/navigation/Navigate.tsx";

export const MissingLocationWarning: FunctionComponent = () => (
  <MessageBar messageBarType={MessageBarType.warning}>
    Location details have not been saved. Update Location information in{" "}
    <Navigate to={routes.settings.practices.basePath.pattern}>
      Settings &gt; Practice &amp; Locations
    </Navigate>
  </MessageBar>
);
